import {register} from 'register-service-worker';
import Swal from 'sweetalert2';

const registryEvent = new CustomEvent('regEvent', {detail: 'registered'});
const appVersionEvent = new CustomEvent('appVerEvent', {detail: 'v2.9.6.20'});
const appDbRegEvent = new CustomEvent('appDbEvent', {dbName: 'safepp-db', dbVersion: '1'});

const updatedEvent = new CustomEvent('updateEvent', {detail: 'updated'});
const updateEvent = new CustomEvent('updateEvent', {detail: 'update downloading'});
const connectionOfflineEvent = new CustomEvent('connEvent', {detail: 'offline'});
const connectionOnlineEvent = new CustomEvent('connEvent', {detail: 'online'});


if (process.env.NODE_ENV === 'production') {

    const cacheName = 'safepp-cache';

    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            document.dispatchEvent(connectionOnlineEvent);
        },
        registered() {

            document.dispatchEvent(registryEvent);
            document.dispatchEvent(appVersionEvent);
            document.dispatchEvent(appDbRegEvent);

            caches.open(cacheName)
                .then(function (cache) {
                    return cache.addAll([
                        '/favicon.ico',
                        '/index.html',
                        '/manifest.json',
                        '/robots.txt',
                        '/service-worker.js',
                        '/service-worker.js.map',
                        '/workbox-dbf1b8dc.js',
                        '/workbox-dbf1b8dc.js.map',
                        '/js/about.4ca0110e.js',
                        '/js/about.4ca0110e.js.map',
                        '/js/app.476c3815.js',
                        '/js/app.476c3815.js.map',
                        '/js/chunk-vendors.e56c29c2.js',
                        '/js/chunk-vendors.e56c29c2.js.map',
                        '/fonts/fa-brands-400.8bf6ccf0.ttf',
                        '/fonts/fa-brands-400.e465758e.woff2',
                        '/fonts/fa-regular-400.a937b755.ttf',
                        '/fonts/fa-regular-400.f386b6b7.woff2',
                        '/fonts/fa-solid-900.081655f2.ttf',
                        '/fonts/fa-solid-900.ce4938a3.woff2',
                        '/fonts/fa-v4compatibility.f8c4829c.ttf',
                        '/css/app.52a70b27.css',
                        '/css/chunk-vendors.cd353c0d.css',
                        '/img/AMH-Africa-Logo.01727e0c.png',
                        '/img/icons/android-chrome-192x192.png',
                        '/img/icons/apple-touch-icon-114x114.png',
                        '/img/icons/apple-touch-icon-152x152.png',
                        '/img/icons/apple-touch-icon-60x60.png',
                        '/img/icons/apple-touch-icon.png',
                        '/img/icons/favicon.svg',
                        '/img/icons/safari-pinned-tab.svg',
                        '/img/icons/android-chrome-512x512.png',
                        '/img/icons/apple-touch-icon-114x114-precomposed.png',
                        '/img/icons/apple-touch-icon-152x152-precomposed.png',
                        '/img/icons/apple-touch-icon-60x60-precomposed.png',
                        '/img/icons/apple-touch-icon-precomposed.png',
                        '/img/icons/html_code.html',
                        '/img/icons/site.webmanifest',
                        '/img/icons/android-chrome-maskable-192x192.png',
                        '/img/icons/apple-touch-icon-120x120.png',
                        '/img/icons/apple-touch-icon-180x180.png',
                        '/img/icons/apple-touch-icon-72x72.png',
                        '/img/icons/msapplication-icon-144x144.png',
                        '/img/icons/apple-touch-icon-120x120-precomposed.png',
                        '/img/icons/apple-touch-icon-180x180-precomposed.png',
                        '/img/icons/apple-touch-icon-72x72-precomposed.png',
                        '/img/icons/favicon-16x16.png',
                        '/img/icons/android-chrome-maskable-512x512.png',
                        '/img/icons/apple-touch-icon-144x144.png',
                        '/img/icons/apple-touch-icon-57x57.png',
                        '/img/icons/apple-touch-icon-76x76.png',
                        '/img/icons/favicon-32x32.png',
                        '/img/icons/mstile-150x150.png',
                        '/img/icons/apple-touch-icon-144x144-precomposed.png',
                        '/img/icons/apple-touch-icon-57x57-precomposed.png',
                        '/img/icons/apple-touch-icon-76x76-precomposed.png',
                        '/img/icons/favicon.ico'
                    ]);
                })

            self.addEventListener('fetch', function (event) {
                event.respondWith(
                    caches.open(cacheName)
                        .then(function (cache) {
                            cache.match(event.request)
                                .then(function (cacheResponse) {
                                    if (cacheResponse)
                                        return cacheResponse
                                    else
                                        return fetch(event.request)
                                            .then(function (networkResponse) {
                                                cache.put(event.request, networkResponse.clone())
                                                return networkResponse
                                            })
                                })
                        })
                )
            });


        },
        cached() {
        },
        updatefound() {
            document.dispatchEvent(updateEvent);
        },
        updated() {
            document.dispatchEvent(updatedEvent);
        },
        offline() {
            document.dispatchEvent(connectionOfflineEvent);
        },
        error(error) {
            Swal.fire({
                title: 'Error during service worker registration',
                text: error,
                icon: 'Error',
            });
        }
    });

    window.addEventListener('offline', () => {
        document.dispatchEvent(connectionOfflineEvent);
    });

    window.addEventListener('online', () => {
        document.dispatchEvent(connectionOnlineEvent);
    });
}
